var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B3FFA3A2-BBFD-4498-B8C1-D4075A995E8B@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-317.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/loaded",
    transform: "translate(317.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#00374D",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0742188,17.6757812 C16.3841146,17.6757812 16.6575521,17.5572917 16.8945312,17.3203125 C17.1315104,17.0833333 17.25,16.8098958 17.25,16.5 L17.25,16.5 L17.25,8.3515625 C17.25,8.04166667 17.1315104,7.76822917 16.8945312,7.53125 C16.6575521,7.29427083 16.3841146,7.17578125 16.0742188,7.17578125 L16.0742188,7.17578125 L13.640625,7.17578125 C13.5130208,6.82942708 13.3033854,6.546875 13.0117188,6.328125 C12.7200521,6.109375 12.3828125,6 12,6 C11.6171875,6 11.2799479,6.109375 10.9882812,6.328125 C10.6966146,6.546875 10.4869792,6.82942708 10.359375,7.17578125 L10.359375,7.17578125 L7.92578125,7.17578125 C7.61588542,7.17578125 7.34244792,7.29427083 7.10546875,7.53125 C6.86848958,7.76822917 6.75,8.04166667 6.75,8.3515625 L6.75,8.3515625 L6.75,16.5 C6.75,16.8098958 6.86848958,17.0833333 7.10546875,17.3203125 C7.34244792,17.5572917 7.61588542,17.6757812 7.92578125,17.6757812 L7.92578125,17.6757812 L16.0742188,17.6757812 Z M12,8.3515625 C11.8359375,8.3515625 11.6992188,8.29231771 11.5898438,8.17382812 C11.4804688,8.05533854 11.4257812,7.9140625 11.4257812,7.75 C11.4257812,7.5859375 11.4804688,7.44921875 11.5898438,7.33984375 C11.6992188,7.23046875 11.8359375,7.17578125 12,7.17578125 C12.1640625,7.17578125 12.3007812,7.23046875 12.4101562,7.33984375 C12.5195312,7.44921875 12.5742188,7.5859375 12.5742188,7.75 C12.5742188,7.9140625 12.5195312,8.05533854 12.4101562,8.17382812 C12.3007812,8.29231771 12.1640625,8.3515625 12,8.3515625 Z M14.9257812,10.6757812 L9.07421875,10.6757812 L9.07421875,9.5 L14.9257812,9.5 L14.9257812,10.6757812 Z M14.9257812,13 L9.07421875,13 L9.07421875,11.8515625 L14.9257812,11.8515625 L14.9257812,13 Z M13.1757812,15.3515625 L9.07421875,15.3515625 L9.07421875,14.1757812 L13.1757812,14.1757812 L13.1757812,15.3515625 Z",
    id: "\\uE85D",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaded);
export default __webpack_public_path__ + "static/media/loaded.8a74e78613c034944ccdff3568ec1187.svg";
export { ForwardRef as ReactComponent };